const About = () => {
  return (
    <div className="work-time-container">
      <div className="fixed-container-about">
        <div className="about-menu">
          <div className="wrapper-about">
            <p className="text-about">
              Компания «<span className="comp-text-about">ТЕХНОГАЗТОРГ</span>»
              основана в 2015 году. МЫ - молодая, динамично развивающаяся
              компания по продаже газов по договорным ценам, а именно:
              углекислоты, смесь МИКС-1, аргон, азот, кислород. Наша компания
              предоставляет стабильное и безопасное обслуживание своих клиентов
              по продаже, заправке баллонов и доставке их по Киеву, так же
              возможен самовывоз по адресу ул. Бориспольская 15. Технологии
              используемые нами - являются одними из самых современных на рынке
              и при условии самовывоза, наши специалисты помогут Вам с
              погрузкой.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
